import isAchCompanyBalanced from './is-ach-company-balanced.js';
import not from './not.js';

const isOffsetRequiredForAchCompany = not(isAchCompanyBalanced);

export default isOffsetRequiredForAchCompany;
